import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalAccountRoute from "@faire/web-api--source/routes/www/brand-portal/account";
import React, { type JSX } from "react";

import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";

export const USPayoutsIA = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="To start receiving payments, you’ll need to connect a bank account to your Faire account. Here’s how you can do that:"
          description={{
            text: "Header of the list in how to receive payments",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <ol>
        <LiItem step={1}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Navigate your <LinkFormatting>Account Settings</LinkFormatting>."
              values={{
                LinkFormatting: (chunks: JSX.Element) =>
                  PayoutsLinkFormatting(chunks, "my-account"),
              }}
              description={{
                text: "First step of the list in how to receive payments",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={2}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Go to the <LinkFormatting> Payouts </LinkFormatting> tab."
              values={{
                LinkFormatting: (chunks: JSX.Element) =>
                  PayoutsLinkFormatting(chunks, "payment"),
              }}
              description={{
                text: "Second step of the list in how to receive payments",
              }}
            />
          </Typography>
        </LiItem>
        <Spacer height="1x" />
        <LiItem step={3}>
          <Typography>
            <StrictLocalMsg
              defaultMessage="Add your your bank information including: account holder name, routing number, and account number."
              description={{
                text: "Third step of the list in how to receive payments",
              }}
            />
          </Typography>
        </LiItem>
      </ol>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="Payouts will be issued according to the payout schedule you choose. This can also be modified on the <BoldFormatting>Payouts tab.</BoldFormatting>"
          values={{
            BoldFormatting: (chunks: JSX.Element) => BoldFormatting(chunks),
          }}
          description={{
            text: "Footer of the list in how to receive payments",
          }}
        />
      </Typography>
    </Column>
  );
};

const PayoutsLinkFormatting = (chunks: JSX.Element, tab: string) => (
  <Button
    variant="tertiary"
    linkTo={brandPortalAccountRoute({ tab })}
    target="_blank"
  >
    <Bold>{chunks}</Bold>
  </Button>
);

const BoldFormatting = (chunks: JSX.Element) => <Bold>{chunks}</Bold>;
